



















import { Component, Vue } from "vue-property-decorator";
import { Input, Tabs } from "ant-design-vue";
import CModal from "@/components/CModal/index.vue";
import ByOld from "./byOld.vue";
import ByCode from "./byCode.vue";

@Component({
  name: "Safe",
  components: {
    CModal,
    ByOld,
    ByCode,
    AInput: Input,
    AInputPassword: Input.Password,
    ATabs: Tabs,
    ATabPane: Tabs.TabPane
  }
})
export default class Safe extends Vue {
  private modalVisible = false;
  private activeKey = "byOld";
  private oldPassword = "";
  private newPassword = "";
  private saving = false;

  private async save() {
    const promise = await (this.$refs as any)[this.activeKey].save();
    if (promise) {
      this.$message.success("保存成功");
      this.modalVisible = false;
      setTimeout(() => (this.activeKey = "byOld"), 500);
    }
  }

  private close() {
    this.activeKey = "byOld";
    (this.$refs as any)[this.activeKey].init();
  }
}
